import { graphql } from "react-apollo";
import SaveButton from '../../components/SaveButton';
import { updatePage } from './queries';

export default graphql(updatePage, { options: { refetchQueries: ['Pages'] } })(SaveButton)
